import styles from "./styles.module.css";

type RunCodeChangesPrefixProps = {
  prefix: string;
  color: string | undefined;
};

const RunCodeChangesPrefix = ({ prefix, color }: RunCodeChangesPrefixProps) => (
  <span className={styles.prefix} style={color ? { color } : undefined}>
    {prefix}
  </span>
);

export default RunCodeChangesPrefix;
